import React from 'react'
import { Card } from '../../elements/Card'
import { TestimonialMiniCard } from '../../elements/TestimonialMiniCard'
import { CardWithImage } from 'marketing-site/src/library/elements/CardWithImage'
import { CardWithModal } from 'marketing-site/src/library/elements/CardWithModal'
import { SolutionCard } from 'marketing-site/src/library/elements/SolutionCard'

import {
  ICardRenderer,
  ICrossLinkCard,
  ITestimonialMiniCard,
  ICardWithImage,
  ICardWithModal,
  ISolutionCard,
} from './index'

const CardRenderer = ({ card, cardColor, alignment }: ICardRenderer): React.ReactElement => {
  switch (card.contentType) {
    default:
      const crossLinkCard = card as ICrossLinkCard
      return <Card {...crossLinkCard} cardColor={cardColor} alignment={alignment} />
    case 'testimonialMiniCard':
      const testimonialMiniCard = card as ITestimonialMiniCard
      return <TestimonialMiniCard {...testimonialMiniCard} />
    case 'cardWithImage':
      const cardWithImage = card as ICardWithImage
      return <CardWithImage {...cardWithImage} />
    case 'cardWithModal':
      const cardWithModal = card as ICardWithModal
      return <CardWithModal {...cardWithModal} />
    case 'solutionCard':
      const solutionCard = card as ISolutionCard
      return <SolutionCard {...solutionCard} />
  }
}

export default CardRenderer
